/* ChatBubble + TypingBubble — chat message rows and animated typing indicator.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';

export type ChatDirection = 'in' | 'out' | 'system';

export interface ChatBubbleProps {
  dir?: ChatDirection;
  text?: React.ReactNode;
  time?: string;
  sender?: string;
  children?: React.ReactNode;
}

export function ChatBubble({
  dir = 'in',
  text,
  time,
  sender,
  children,
}: ChatBubbleProps) {
  if (dir === 'system') {
    return (
      <div className="chat-row system">
        <div className="chat-bubble">{text || children}</div>
      </div>
    );
  }

  return (
    <div className={'chat-row ' + dir}>
      <div style={{ maxWidth: '78%' }}>
        <div className="chat-bubble">{text || children}</div>
        {(time || sender) && (
          <div className="chat-meta">
            {sender ? sender + ' · ' + time : time}
          </div>
        )}
      </div>
    </div>
  );
}

export function TypingBubble() {
  return (
    <div className="chat-row in">
      <div className="chat-bubble" style={{ padding: 0 }}>
        <div className="typing">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}

export default ChatBubble;
